{
  "appointment": {
    "CONFIRMATION_NUMBER": "Confirmation #",
    "APPOINTMENT_ID": "Appointment ID",
    "APPOINTMENT_DATE": "Appt Date",
    "APPOINTMENT_TIME": "Appt Time",
    "APPOINTMENT_TIMEZONE": "Timezone",
    "APPOINTMENT_TYPE": "Appointment Type",
    "SCHEDULED_DURATION": "Scheduled Duration (mins)",
    "STATUS": "Status",
    "ARRIVAL_DATE": "Arrival Date",
    "ARRIVAL_TIME": "Arrival Time",
    "DEPARTURE_DATE": "Departure Date",
    "DEPARTURE_TIME": "Departure Time",
    "DWELL_TIME": "Dwell Time (mins)",
    "ON_TIME": "On-Time (mins)",
    "IN_PROGRESS_DATE": "In Progress date",
    "IN_PROGRESS_TIME": "In Progress time",
    "WAIT_TIME": "Wait time (mins)",
    "PROCESSING_TIME": "Processing time (mins)",
    "WAREHOUSE": "Warehouse",
    "DOCK": "Dock",
    "LOAD_TYPE": "Load Type",
    "LOAD_TYPE_DIRECTION": "Direction",
    "RESCHEDULE_COUNT": "Reschedule Count",
    "CREATED_BY": "Created By",
    "CREATOR_TYPE": "Creator Type",
    "CREATION_DATE": "Creation Date",
    "LAST_UPDATED_BY": "Last Updated By",
    "LAST_UPDATE_DATE": "Last Update Date",
    "LAST_UPDATE_TIME": "Last Update Time",
    "CARRIER_COMPANY": "Carrier Company",
    "CONTACT_NAME": "Contact Name",
    "CONTACT_EMAIL": "Contact Email",
    "CONTACT_PHONE": "Contact Phone",
    "NOTES": "Notes",
    "TAGS": "Tags",
    "CUSTOM_FIELDS": "Custom Fields",
    "EXTERNAL_VALIDATION_STATUS": "External Validation Status",
    "EXTERNAL_VALIDATION_ERROR_MESSAGE": "External Validation Error Message",
    "CheckOut": "Check-out",
    "CheckInAdditionalAssetDetails": "Check-in additional asset details",
    "InboundClaim": "Inbound Claim",
    "OutboundClaim": "Outbound Claim",
    "BookLoadType": "Book Load Type",
    "AssetContainerDetails": "Asset container details",
    "AppointmentCompleted": "Appointment Completed"
  },
  "assetVisit": {
    "id": "Visit ID",
    "appointmentId": "Appointment ID",
    "checkInDate": "Check-in Date/Time",
    "checkOutDate": "Check-out Date/Time",
    "carrier": "Carrier",
    "warehouseName": "Warehouse",
    "currentStatus": "Status",
    "licensePlate": "License Plate",
    "visitType": "Visit Type",
    "dotNumber": "DOT Number",
    "phone": "Phone",
    "isPlanned": "Planned",
    "driverNotes": "Driver Notes",
    "checkInAcknowledged": "Check-in Acknowledged",
    "firstName": "ID Verification First Name",
    "lastName": "ID Verification Last Name",
    "birthdate": "ID Verification Birthdate",
    "idValidationEmail": "ID Verification Email",
    "idValidationPhone": "ID Verification Phone"
  }
}
